import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import {SelecaoFiltroPage} from './selecao-filtro.page';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
    ],
    declarations: [
        SelecaoFiltroPage
    ],
    entryComponents: [
        SelecaoFiltroPage
    ]
})
export class SelecaoFiltroModule { }
